// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-7eDE","col":"styles_col__2B8Rq"};